/**
 * Component to Add or Edit a single organization
 */
import * as React from 'react';
import { Card, Row, Col, Input, Button, message, Breadcrumb, Icon, Checkbox } from 'antd';
import { IcommonProps } from '../common/props';
import '../../css/OrganizationAddEdit.scss';
import Util from '../common/utils';
import service from '../../service/apolloclient.service';
import { MSGDISPLAYTIME } from '../common/constants';
import { VIEWSTATE } from '../common/constants';
import { staticProperties, STATICKEYS }  from '../common/staticProperties';
import strings from '../../eyeguide-localization/customer/string.customer.add';
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';

const EVENT = {
    EDITORG: '/customer/edit/'
};

/**
 * Property definition 
 */
interface ICustomerEditProps extends IcommonProps {

    save: any;
    cancel: any;
    navigationFrom: any;
    match: any;
    location: any;
    notifyCustomerUpdate: any;
}

/**
 * State definition
 */
interface ICustomerEditState {
    classesWithErr: string;
    classesWithoutErr: string;
    errorname:    boolean;
    errorCname:    boolean;
    errorCphone:    boolean;
    errorCemail:    boolean;
    organization: any;
    name:           string;
    contactfname:    string;
    contactlname:    string;  
    contactphone:   string;
    contactemail:   any;
    address:        string;
    email:          string;
    website:        string;
    testtags:       string;
    enableprivacy:  boolean;
    enablebestbaseline: boolean;
    viewinapptest:  boolean;
    viewinappbaseline: boolean;
    country:        string;
    region:         string;
    errorLname:     boolean;
    jobTitle:       string;
    city:           string;
    pincode:        string;
    showNameCheck:  boolean;
    nameCheckType:  string;
    nameCheckColor: string;
    enablefailedtestreport: boolean;
}

var search: any = undefined;

export default class CustomerEdit extends React.Component<ICustomerEditProps, ICustomerEditState> {

    constructor(props: ICustomerEditProps) {
        super(props); 
        this.state = {
            classesWithErr : 'fill errorHighlight',
            classesWithoutErr: 'fill',
            errorname: false,
            errorCname: false,
            errorCemail: false,
            errorCphone: false,
            name            : '',
            contactfname     : '',
            contactlname     : '',
            contactphone    : '',
            address         : '',
            website         : '',
            contactemail    : '',
            email           : '',
            organization: [],
            country         : '',
            region          : '',
            city            : '',
            errorLname      : false,
            jobTitle        : '',
            pincode         : '',
            showNameCheck   : false,
            nameCheckType   : '',
            nameCheckColor  : '',
            testtags        : '',
            enableprivacy   : false,
            viewinapptest   : false,
            viewinappbaseline : false,
            enablebestbaseline: false,
            enablefailedtestreport: false
        };
        this.processOrg = this.processOrg.bind(this);
    }

    async componentDidMount() {
        Util.resetScroll();
        console.log('componentDidUpdate');
        staticProperties.set(STATICKEYS.selectedKey, VIEWSTATE.CUSTOMER);
        staticProperties.set(STATICKEYS.selectedRoster, '');
        if (this.props.location.pathname.startsWith(EVENT.EDITORG)) {
            await this.getCustomerToEdit(this.props.match.params.orgid);
        }
        this.setState({
            name: this.state.organization.name,
            contactfname: this.state.organization.contactfirstname,
            contactlname: this.state.organization.contactlastname,
            contactphone: this.state.organization.contactphone,
            address: this.state.organization.address,
            email: this.state.organization.email,
            website: this.state.organization.website,
            contactemail: this.state.organization.contactemail,
            country         : this.state.organization.country,
            region          : this.state.organization.state,
            city            : this.state.organization.city,
            errorLname      : false,
            jobTitle        : this.state.organization.jobtitle,
            pincode         : this.state.organization.pincode,
            testtags        : this.state.organization.testtags,
            enableprivacy   : this.state.organization.enableprivacy,
            viewinapptest   : this.state.organization.viewinapptest,
            viewinappbaseline : this.state.organization.viewinappbaseline,
            enablebestbaseline: this.state.organization.enablebestbaseline,
            enablefailedtestreport: this.state.organization.enablefailedtestreport
        });
    }

    render() { 
        // if (this.props.organization === '') { // if organization is empty, call is from Add Organization
        //     this.resetControls();
        // }
        console.log('org', this.state.organization);
        return (
            <div className="OrganizationAddEdit">
                <Card >
                    <Breadcrumb>
                        <Breadcrumb.Item><a href="/dashboard">{strings.lsHomeTxt}</a></Breadcrumb.Item>
                        <Breadcrumb.Item><a href="/customer">{strings.lsOrgsTxt}</a></Breadcrumb.Item>
                        <Breadcrumb.Item> {strings.lsEditTxt}
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <br/>
                    <h3>{strings.lsEditOrgTxt} </h3>
                </Card>
                <Card bordered={false} style={{ margin: '24px 16px' }} >
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={4} xl={5} />
                        <Col xs={8} sm={8} md={5} lg={6} xl={5} className="labelFrame">
                            <div className="label">
                                <span>{strings.lsOrgName}
                                    <span className="labelReq"> * </span>
                                :</span>
                            </div>
                        </Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                            <Input 
                                value={this.state.name}
                                onChange={(val) => this.setState({name: val.target.value})}
                                className={this.state.errorname ? 
                                        this.state.classesWithErr : this.state.classesWithoutErr}
                                placeholder="e.g. High School USA" 
                                autoFocus={true}
                                onBlur={() => this.validateCustomerName()}
                            />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={3} xl={4}>                   
                    {this.state.showNameCheck ? 
                        <div>
                        <Col xs={1} sm={1} md={2} lg={4} xl={5}>
                        <Icon 
                            style={{paddingTop: '5px' , 
                                    color: this.state.nameCheckColor , 
                                    fontSize: '19px'}}
                            className="iconStyle"
                            type={this.state.nameCheckType}
                        /> </Col>
                        <Col xs={1} sm={1} md={2} lg={20} xl={19}>
                        {this.state.nameCheckColor === 'red' ? 
                            <span className="hyphenate"> {strings.lsCustomerExistsTxt} 
                            </span> : ''}
                        </Col>
                        </div>
                        : ''}
                    </Col>              
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={4} xl={5} />
                        <Col xs={8} sm={8} md={5} lg={6} xl={5} className="labelFrame">
                            <div className="label">
                                <span>{strings.lsContactFirstNameTxt} 
                                    <span className="labelReq"> * </span>     
                                :</span>
                            </div>
                        </Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                            <Input 
                                value={this.state.contactfname}
                                onChange={(val) => this.setState({contactfname: val.target.value})}
                                className={this.state.errorCname ? 
                                                this.state.classesWithErr : this.state.classesWithoutErr}
                                placeholder="e.g. Johnny"
                            />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={3} xl={4}/>
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={4} xl={5} />
                        <Col xs={8} sm={8} md={5} lg={6} xl={5} className="labelFrame">
                            <div className="label">
                                <span>{strings.lsContactLastNameTxt} 
                                    <span className="labelReq"> * </span>     
                                :</span>
                            </div>
                        </Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                            <Input 
                                value={this.state.contactlname}
                                onChange={(val) => this.setState({contactlname: val.target.value})}
                                className={this.state.errorLname ? 
                                                this.state.classesWithErr : this.state.classesWithoutErr}
                                placeholder="e.g. Thomas"
                            />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={3} xl={4}/>
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={4} xl={5} />
                        <Col xs={8} sm={8} md={5} lg={6} xl={5} className="labelFrame">
                            <div className="label">
                                <span>{strings.lsContactJobTitle} 
                                :</span>
                            </div>
                        </Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                            <Input 
                                value={this.state.jobTitle}
                                onChange={(val) => this.setState({jobTitle: val.target.value})}
                                placeholder="e.g. Manager"
                            />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={3} xl={4}/>
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={4} xl={5} />
                        <Col xs={8} sm={8} md={5} lg={6} xl={5} className="labelFrame">
                        <div className="label">
                                <span>{strings.lsContactPhoneTxt} 
                                    <span className="labelReq"> * </span>     
                                :</span>
                        </div>
                        </Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                            <Input 
                                value={this.state.contactphone}
                                onChange={(val) => this.setState({contactphone: val.target.value})}
                                className={this.state.errorCphone ? 
                                    this.state.classesWithErr : this.state.classesWithoutErr}
                                placeholder="e.g. 123-456-789" 
                            />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={4} xl={5} />
                        <Col xs={8} sm={8} md={5} lg={6} xl={5} className="labelFrame">
                        <div className="label">
                                <span>{strings.lsContactEmailTxt} 
                                    <span className="labelReq"> * </span>     
                                :</span>
                        </div>
                        </Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                            <Input
                                value={this.state.contactemail}
                                onChange={(val) => this.setState({contactemail: val.target.value})}
                                className={this.state.errorCemail ? 
                                    this.state.classesWithErr : this.state.classesWithoutErr}
                                placeholder="e.g. johny.thomas@school.edu" 
                            />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={4} xl={5} />
                        <Col xs={8} sm={8} md={5} lg={6} xl={5} className="labelFrame">
                        <div className="label">{strings.lsAddressTxt} :</div></Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                            <Input 
                                value={this.state.address}
                                onChange={(val) => this.setState({address: val.target.value})}
                                placeholder="e.g. 123 At, Philadelphia, PA" 
                            />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={3} xl={4}/>
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={4} xl={5} />
                        <Col xs={8} sm={8} md={5} lg={6} xl={5} className="labelFrame">
                        <div className="label">{strings.lsCityTxt} :</div></Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                            <Input 
                                value={this.state.city}
                                onChange={(val) => this.setState({city: val.target.value})}
                                placeholder="e.g. Franklin" 
                            />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={3} xl={4}/>
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={4} xl={5} />
                        <Col xs={8} sm={8} md={5} lg={6} xl={5} className="labelFrame">
                        <div className="label">{strings.lsStateTxt} :</div></Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                        <div className="selectdiv">
                            <RegionDropdown
                                    classes="contentCountry"
                                    blankOptionLabel={strings.lsSelectRegion}
                                    defaultOptionLabel={strings.lsSelectRegion}
                                    country={this.state.country}
                                    value={this.state.region}
                                    onChange={(val) => this.selectRegion(val)} 
                            />
                        </div>
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={4} xl={5} />
                        <Col xs={8} sm={8} md={5} lg={6} xl={5} className="labelFrame">
                        <div className="label">{strings.lsCountryTxt} :</div></Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                        <div className="selectdiv">
                            <CountryDropdown
                                classes="contentCountry"
                                value={this.state.country}
                                onChange={(val) => this.selectCountry(val)} 
                            />
                        </div>
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={4} xl={5} />
                        <Col xs={8} sm={8} md={5} lg={6} xl={5} className="labelFrame">
                        <div className="label">{strings.lsZipPostalCodeTxt} :</div></Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                            <Input 
                                value={this.state.pincode}
                                onChange={(val) => this.setState({pincode: val.target.value})}
                                placeholder="e.g. 10080" 
                            />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={1} lg={4} xl={5} />
                        <Col xs={8} sm={8} md={6} lg={6} xl={5} className="labelFrame">
                            <div className="label">{strings.lsOrgEmailTxt} :</div>
                        </Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                            <Input 
                                value={this.state.email}
                                onChange={(val) => this.setState({email: val.target.value})}
                                placeholder="e.g. admin@school.edu" 
                            />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={1} lg={4} xl={5} />
                        <Col xs={8} sm={8} md={6} lg={6} xl={5} className="labelFrame">
                        <div className="label">{strings.lsWebsiteTxt} :</div></Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                            <Input 
                                value={this.state.website}
                                onChange={(val) => this.setState({website: val.target.value})}
                                placeholder="e.g. www.schoolsite.edu" 
                            />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                    </Row>
                    <Row className="row">
                    <Col xs={1} sm={1} md={1} lg={3} xl={5} />
                    <Col xs={8} sm={8} md={6} lg={6} xl={5} className="labelFrame">
                    <div className="label">{strings.IsTestTags} :</div></Col>
                    <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                        <Row className="tagsContainer" hidden={!this.state.testtags || this.state.testtags === ''}>
                            <Col>
                                {this.renderTags()}
                            </Col>
                        </Row>
                        <Row>
                            <Input.Search
                                ref={(e) => search = e}
                                enterButton={<Icon type="plus" />}
                                onSearch={(val) => this.handleAddTag(val)}
                                placeholder="e.g. Test" 
                            />
                        </Row>
                    </Col>
                    <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={1} lg={4} xl={5} />
                        <Col xs={8} sm={8} md={6} lg={6} xl={5} className="labelFrame checkboxFrame">
                        <div className="label">{strings.lsEnableBestBaseline} :</div></Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                            <Checkbox 
                                checked={this.state.enablebestbaseline}
                                onChange={(e) => this.setState({enablebestbaseline: e.target.checked})}
                            />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={1} lg={4} xl={5} />
                        <Col xs={8} sm={8} md={6} lg={6} xl={5} className="labelFrame checkboxFrame">
                        <div className="label">{strings.lsEnableFailedTestReport} :</div></Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                            <Checkbox 
                                checked={this.state.enablefailedtestreport}
                                onChange={(e) => this.setState({enablefailedtestreport: e.target.checked})}
                            />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                    </Row>
                    { this.state.enableprivacy && <Row className="row" type="flex">
                        <Col xs={1} sm={1} md={1} lg={3} xl={5} />
                        <Col xs={8} sm={8} md={6} lg={6} xl={5} className="labelFrame checkboxFrame">
                        <div className="label">{strings.IsViewInAppTestTxt} :</div>
                        </Col>
                        <Col>
                            <Checkbox 
                                checked={this.state.viewinapptest}
                                onChange={(e) => this.setState({viewinapptest: e.target.checked})}
                            />
                        </Col>
                        <Col xs={8} sm={8} md={6} lg={6} xl={4} className="labelFrame checkboxFrame">
                            <div className="label">{strings.IsViewInAppBaseline} :</div>
                        </Col>
                        <Col >
                            <Checkbox 
                                checked={this.state.viewinappbaseline}
                                onChange={(e) => this.setState({viewinappbaseline: e.target.checked})}
                            />
                        </Col>
                        <Col />
                    </Row>}
                    {/* <Row className="row">
                        
                    </Row> */}
                    <Row>
                        <Col span={12} style={{padding: '10px'}}>
                            <div className="buttonRight"> 
                                <Button 
                                    onClick={e => {
                                        this.processOrg
                                        (this.getOrgObj(), 
                                         0, 
                                         this.state.organization.organizationid); // save
                                    }}     
                                    type="primary" 
                                    style={{width: '100%'}}
                                > 
                                    {this.state.organization instanceof Array && 
                                            this.state.organization.length === 0 ? strings.lsAddTxt 
                                            : strings.lsSaveTxt} 
                                </Button> 
                            </div>
                        </Col>
                        <Col span={12} style={{padding: '10px'}}>
                            <div className="buttonLeft"> 
                                <Button 
                                        onClick={e => {
                                            history.back();
                                                    }} 
                                        type="danger" 
                                        style={{width: '100%'}}
                                > 
                                {strings.lsCancelTxt} 
                                </Button> 
                            </div>
                        </Col>
                    </Row>
                </Card>
            </div>
        );
    }

    renderTags() {
        var list = this.state.testtags ? this.state.testtags.split(',') : [];
        return list.map((item, index) => {
            return item !== '' ? ( 
                <Row justify="end" className="testTag" key={item + index}> 
                    <Col className="text"><span>{item}</span></Col>
                    <Col className="iconCol">
                        <Icon 
                            className="tagIcon" 
                            type="delete" 
                            onClick={(e => this.handleDeleteTag(item))}
                        />
                    </Col> 
                </Row>
            ) : null;
        });
    }

    /**
     * coverts string into an array and removes the item.
     * @param item tag
     */
    handleDeleteTag(item: string) {
        var list = this.state.testtags.split(',');
        list.splice(list.indexOf(item), 1);
        this.setState({testtags: list.join(',')});
    }

    /**
     * appends the item to the coma seperated list
     * @param item tag
     */
    handleAddTag(item: string) {
        search.input.input.value = '';
        return item.match(/^\s+$|^$/gi) ? null : this.setState({testtags: this.state.testtags ? 
            this.formatTags(this.state.testtags, true) + item + ',' : item + ','});
    }

    /**
     * Removes or appends the comma from the string as needed
     * @param testtags comma seperated string 
     * @param isStart if true checks the end of the string for a comma
     */
    formatTags(testtags: string, isStart: boolean) {
        var str = isStart ? 
            (testtags[testtags.length - 1] !== ',' ? 
            testtags + ',' : testtags) :
            (testtags[testtags.length - 1] === ',' ? 
            testtags.slice(0, testtags.length - 1) : testtags);
        return str;
    }

    /**
     * Returns organization object in json format
     * to be sent to server for processing
     */
    private getOrgObj(): any {
        if (this.validateInput() && this.state.nameCheckColor !== 'red') {
            let inputOrg: any = {
                'name': this.state.name !== null ? this.state.name.trim() : '',
                'contactfirstname': this.state.contactfname !== null ? this.state.contactfname.trim() : '',
                'contactlastname': this.state.contactlname !== null ? this.state.contactlname.trim() : '',
                'contactphone': this.state.contactphone !== null ? this.state.contactphone.trim() : '',
                'jobtitle': this.state.jobTitle !== null ? this.state.jobTitle.trim() : '',
                'contactemail': this.state.contactemail !== null ? this.state.contactemail.trim() : '',
                'address': this.state.address !== null && this.state.address !== undefined
                                     ? this.state.address.trim() : '',
                'city': this.state.city !== null && this.state.city !== undefined
                ? this.state.city.trim() : '',
                'state': this.state.region !== null && this.state.region !== undefined
                ? this.state.region.trim() : '',
                'country': this.state.country !== null && this.state.country !== undefined
                ? this.state.country.trim() : '',
                'pincode': this.state.pincode !== null && this.state.pincode !== undefined
                ? this.state.pincode.trim() : '',

                'email': this.state.email !== null && this.state.email !== undefined 
                                     ? this.state.email.trim() : '',
                'website': this.state.website !== null && this.state.website !== undefined
                                     ? this.state.website.trim() : '',
                'testtags': this.state.testtags !== null && this.state.testtags !== undefined
                                    ? this.formatTags(this.state.testtags, false) : '',
                'viewinapptest': this.state.viewinapptest ? true : false,
                'viewinappbaseline': this.state.viewinappbaseline ? true : false,
                'enablebestbaseline' : this.state.enablebestbaseline ? true : false,
                'enablefailedtestreport' : this.state.enablefailedtestreport ? true : false
                };  
            return inputOrg;
        } else {
            return '';
        }       
    }

    /**
     * Validates the username provided by user while creating user,
     * by calling the server
     */
    private async validateCustomerName() {
        console.log('validate', this.state.name !== null && this.state.name !== undefined 
                                ? this.state.name.trim() : '');
        let ser = new service();
        let response: any;
        if (this.state.name.trim() !== this.state.organization.name) {  
            if (this.state.name !== null && this.state.name !== undefined
                            && this.state.name.trim().length > 0 ) {
                    response = await ser.verifyCustomerName(this.state.name.trim());
                    console.log('response', response);
                    if (response.status === 0) { // success
                        this.setState({
                            showNameCheck: true,
                            nameCheckType: 'check-circle', // 'check-circle'
                            nameCheckColor: '#4ddb33b0' // '#4ddb33b0'
                        });
                    } else {
                        this.setState({
                            showNameCheck: true,
                            nameCheckType: 'close-circle', // 'check-circle'
                            nameCheckColor: 'red' // '#4ddb33b0'
                        });
                    }
                }
            }
        }
    
    /**
     * Validate input values provided by the user before submitting to server 
     */
    private validateInput(): boolean {
        let isValid: boolean = true;
        let errorname: boolean = false;
        let errorCname: boolean = false;
        let errorLname: boolean = false;
        let errorCphone: boolean = false;
        let errorCemail: boolean = false;
        this.state.name !== null && (this.state.name === undefined || this.state.name.trim() === '') ? 
                    errorname = true : errorname = false;
        this.state.contactfname !== null && 
                (this.state.contactfname === undefined || this.state.contactfname.trim() === '') ? errorCname = true 
                    : errorCname = false;
        this.state.contactlname !== null && 
                (this.state.contactlname === undefined || this.state.contactlname.trim() === '') ? errorLname = true 
                        : errorLname = false;
        this.state.contactphone !== null && 
                    (this.state.contactphone === undefined || this.state.contactphone.trim() === '')
                    ? errorCphone = true 
                    : errorCphone = false;
        this.state.contactemail !== null &&  
                    (this.state.contactemail === undefined || this.state.contactemail.trim() === '') 
                    ? errorCemail = true 
                : errorCemail = false;
        console.log('validate Email', Util.validateEmail(this.state.email));
        errorCemail = errorCemail ? errorCemail : !Util.validateEmail(this.state.contactemail);
        if (errorname || errorCname || errorCphone || errorCemail || errorLname) { isValid = false; }
        this.setState({errorname, errorCname, errorCemail, errorCphone});
        return isValid;
    }
   
    /**
     * Handles organization add / update as per the event sent.
     * @param org Customer Object to Add/Update
     * @param event Event to process. 1 - Add else Update
     * @param orgId Customer id
     */
    private async processOrg(org: any, event: number, orgId: string) {
        console.log('processOrg', orgId);
        let ser = new service();
        let orgResponse: any = await ser.updateSubOrganization(org, orgId);
        if (orgResponse.status === 0) {
            message.success(strings.lsUpdateOrgSuccessTxt, MSGDISPLAYTIME);
        } else if (orgResponse.status === 1) {
            message.error(strings.lsOrgExistTxt, MSGDISPLAYTIME);
        } else {
            message.error(strings.lsUpdateOrgFailedTxt, MSGDISPLAYTIME);
        } 
        this.props.notifyCustomerUpdate();
        history.back();
    }

    private async getCustomerToEdit(id: any) {
        let ser = new service();
        let org: any = await ser.getOrganization(id);
        console.log('getOrganizationresponse', org);
        this.setState({organization: org});
    }

    private selectCountry (val: string) {
        this.setState({ country: val });
    }

    private selectRegion(val: string) {
        this.setState({ region: val });
    }

}



// WEBPACK FOOTER //
// ./src/components/customer/CustomerEdit.tsx